export enum AnalyticActionEnum {
  FOCUS = 'focus',
  CHANGE = 'change',
  BLUR = 'blur'
}

export enum AnalyticFormStatusEnum {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum AnalyticConsentStatusEnum {
  SELECT = 'select',
  DESELECT = 'deselect',
}

export enum AnalyticConsentEventEnum {
  GENERAL_CONSENT_GIVEN = 'general_consent_given',
  INSURANCE_CONSENT_GIVEN = 'insurance_consent_given',
  MARKETING_CONSENT_GIVEN = 'marketing_consent_given',
  ANALYZE_DOCUMENT_PASSED = 'analyze_document_passed',
}
